module.exports = __webpack_public_path__ + "img/slider-6.a4618c04.jpg";